import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteRoomsConfig, invalidateRoomsConfigCache, listRoomsConfigs, saveRoomsConfig } from './api';
import { RoomsConfigInput } from './types';

const KEY = ['admin-rooms-config'] as const;
export const useRoomsConfigs = () => useQuery({ queryKey: KEY, queryFn: listRoomsConfigs });
export function useSaveRoomsConfig() {
  const client = useQueryClient();
  return useMutation({ mutationFn: ({ input, id }: { input: RoomsConfigInput; id?: number }) => saveRoomsConfig(input, id), onSuccess: () => client.invalidateQueries({ queryKey: KEY }) });
}
export function useDeleteRoomsConfig() {
  const client = useQueryClient();
  return useMutation({ mutationFn: deleteRoomsConfig, onSuccess: () => client.invalidateQueries({ queryKey: KEY }) });
}

export function useInvalidateRoomsConfigCache() {
  const client = useQueryClient();
  return useMutation({ mutationFn: invalidateRoomsConfigCache, onSuccess: () => client.invalidateQueries({ queryKey: KEY }) });
}
